import { render, staticRenderFns } from "./WorkItemDetailEdit.vue?vue&type=template&id=653d6114&"
import script from "./WorkItemDetailEdit.vue?vue&type=script&lang=js&"
export * from "./WorkItemDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorkItemDetailEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports